/**
 * @file SelectやMultiTagFilteringFieldなどの選択肢を表すコンポーネントで慣例的に使用されている型とユーティリティ関数のまとめ
 */

/** Select系コンポーネントのoptionsで慣例的に使用されている要素の型 */
export interface Option {
  label: string
  value: string
}

/** MultiTagFilteringFieldのlistの要素の型 */
export interface TagFilterItem {
  id: string
  name: string
}

/** Option[] -> TagFilterItem[] */
export const fromOpts = (opt: Option[]): TagFilterItem[] => opt.map((opt) => ({name: opt.label, id: opt.value}))

/** TagFilterItem[] -> Option[] */
export const toOpts = (data: TagFilterItem[]): Option[] => data.map((item) => ({label: item.name, value: `${item.id}`}))

/** 未入力を表すTagFilterItemを追加 */
export const withNull = <T>(lst: T[] | null | undefined): (T | TagFilterItem)[] => [
  ...(lst || []),
  {name: '未入力', id: 'null'},
]

/** 未入力を表すOptionを追加 */
export const withNullOpt = <T>(lst: T[] | null | undefined): (T | Option)[] => [
  ...(lst || []),
  {label: '未入力', value: 'null'},
]
